import { render, staticRenderFns } from "./RegionSelector.vue?vue&type=template&id=54ceea73&scoped=true"
import script from "./RegionSelector.vue?vue&type=script&lang=js"
export * from "./RegionSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ceea73",
  null
  
)

export default component.exports